import { getContent } from "../state";

type State = any;

export function getParentId(state: State, contentId: string): string {
  const content = getContent(state, contentId);
  return content.parentId;
}
